import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';

import { ROLE } from '../../const';
import * as groupsApi from '../../services/api/groupApi';

class GroupAssignedTile extends Component {
  render() {
    const { assignedGroup, groups, ligthColor, withMargin } = this.props;
    const color = ligthColor ? 'ligth' : 'dark';

    if (!assignedGroup) return <div />;
    let groupText = I18n.t('groups.custom');
    let groupColor = 'all';
    if (!assignedGroup.users.length) {
      let groupId = 0;
      if (assignedGroup.groups.length) {
        groupId = assignedGroup.groups[0];
      }
      const selectedGroup = groups.filter(group => group.id === groupId);
      if (selectedGroup.length) {
        groupText = groupsApi.getGroupName(selectedGroup[0]);
        groupColor = selectedGroup[0].colour;
      }
    }

    const isTeacher = this.props.role === ROLE.INSTRUCTOR;

    return isTeacher ? (
      <div
        className={
          withMargin
            ? `with-button group-assigned ${color} group-item-${groupColor}`
            : `group-assigned ${color} group-item-${groupColor}`
        }
      >
        {groupText}
      </div>
    ) : null;
  }
}

GroupAssignedTile.propTypes = {
  assignedGroup: PropTypes.object,
  groups: PropTypes.array,
  ligthColor: PropTypes.bool,
  role: PropTypes.string,
  withMargin: PropTypes.bool
};

GroupAssignedTile.defaultProps = {
  ligthColor: false
};

export default GroupAssignedTile;
